/**
 * HipaaAckBanner — the user MUST acknowledge that the person they are
 * granting access to has a HIPAA-permitted purpose. Server enforces this
 * on first grant per session; UI puts it in plain view so the click is
 * not silent.
 */
import React from 'react';

export default function HipaaAckBanner({ checked, onChange }) {
  return (
    <label style={{
      display: 'flex', alignItems: 'flex-start', gap: 10,
      marginTop: 14, padding: '10px 12px',
      background: '#fff7ed', border: '1px solid #fed7aa',
      borderRadius: 6,
      cursor: 'pointer',
    }}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange?.(e.target.checked)}
        style={{ marginTop: 3 }}
      />
      <span style={{ fontSize: 12, color: '#7c2d12', lineHeight: 1.5 }}>
        I confirm this person has a HIPAA-permitted purpose for accessing the selected applications,
        and that this access is recorded in our compliance program.
      </span>
    </label>
  );
}
